import { Typography, capitalize} from '@tunasong/ui-lib'
import { useEditor, useEditorMessage } from '@tunasong/plugin-lib'
import type { CoreElement } from '@tunasong/schemas'
import { PulseProgress, useCmdHotkey } from '@tunasong/ui-lib'
import cn from 'classnames'
import type { FC } from 'react'
import React, { useCallback } from 'react'
import styles from './empty-block.module.css'

export interface EmptyBlockProps {
  className?: string
  element: CoreElement
  name: string
  Icon: FC
  loading?: boolean
}

export const EmptyBlock: FC<EmptyBlockProps> = props => {
  const { className, name, Icon, element, loading = false } = props
  const editor = useEditor()
  const propertiesCmd = useCmdHotkey('Block: Properties')
  const showProperties = useEditorMessage({ editor, type: 'show-block-properties' })

  const handleClick: React.MouseEventHandler<HTMLSpanElement> = useCallback(
    ev => {
      showProperties(element, ev.currentTarget)
    },
    [element, showProperties]
  )

  return (
    <Typography
      className={cn(styles.emptyBlock, className)}
      contentEditable={false}
      variant="caption"
      onClick={handleClick}
    >
      <Icon />
      {loading ? (
        <PulseProgress />
      ) : (
        <>
          {capitalize(name)} block is not configured.
          {propertiesCmd?.label} or click on this block to configure.
        </>
      )}
    </Typography>
  )
}
